// extracted by mini-css-extract-plugin
export default {"giftButton":"giftButton-GHpApb8k"};